module.exports = __webpack_public_path__ + "img/58.3f36f7a7.jpg";